import { inject, Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  translateService = inject(TranslateService)

  // TODO Why would the duration ever be undefined?
  transform(secondsToConvert: number | null | undefined, showSeconds = false, abbreviate = true): unknown {
    if (typeof secondsToConvert !== 'number') {
      return '-'
    }
    if (secondsToConvert === 0) {
      return '0'
    }
    if (secondsToConvert < 60 && !showSeconds) {
      return `1 ${abbreviate ? this.translateService.instant('COMMON.MINUTE_ABBREVIATION') : this.translateService.instant('COMMON.MINUTE')}`
    }

    const hours = Math.floor(secondsToConvert / 3600)
    const minutes = Math.floor((secondsToConvert % 3600) / 60)
    const seconds = Math.floor(secondsToConvert % 60)

    const getLabel = (value: number, unit: 'HOUR' | 'MINUTE' | 'SECOND') => {
      const key = abbreviate ? `COMMON.${unit}_ABBREVIATION` : `COMMON.${unit}${value > 1 ? 'S' : ''}`
      return this.translateService.instant(key)
    }
    const hoursString = hours > 0 ? `${hours} ${getLabel(hours, 'HOUR')} ` : ''
    const minutesString = `${minutes} ${getLabel(minutes, 'MINUTE')}`
    const secondsString = showSeconds ? ` ${seconds} ${getLabel(seconds, 'SECOND')}` : ''

    return `${hoursString}${minutesString}${secondsString}`.trim()
  }
}
